import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { Customer } from "@/types";

export function useCustomers(): UseQueryResult<Customer[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: queryKeys.list("customers"),
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<Customer[]>("/customers");
    },
    enabled: !!session,
  });
}

export function useCustomer(id: string | undefined): UseQueryResult<Customer> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: id ? queryKeys.detail("customers", id) : ["resources", "customers", "_invalid"],
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<Customer>(`/customers/${id}`);
    },
    enabled: !!id && !!session,
  });
}
